import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GetSingleCourse from "../../../../Controllers/Admin/ClassAndCourses/GetSingleCourse";
import GetSingleExam from "../../../../Controllers/Admin/Exams/GetSingleExam";
import GetSingleResult from "../../../../Controllers/Admin/Results/GetSingleResult";
import GetUsersIncludesInArray from "../../../../Controllers/Admin/Results/GetUsersIncludesInArray";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

export default function ExamResultViewModel() {
  const navigate = useNavigate();
  const location = useLocation();

  const [ExamType, setExamType] = useState("");
  const [CourseName, setCourseName] = useState("");

  const [UsersIds, setUsersIds] = useState([]);
  const [UsersData, setUsersData] = useState([]);
  const [ResultID, setResultID] = useState("");
  const [ExamID, setExamID] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [ResultData, setResultData] = useState({});
  const [ExamData, setExamData] = useState({});

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setExamID(LocationArray.slice(-3, -2)[0]);
    setResultID(LocationArray.slice(-1)[0]);
  }, [location.pathname]);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const ResultObject = await GetSingleResult(ResultID);
      setResultData(ResultObject);

      const CourseData = await GetSingleCourse(ResultObject?.CourseID);
      const ArrayOfWords = CourseData?.CourseName.split(" ");
      for (var i = 0; i < ArrayOfWords.length; i++) {
        ArrayOfWords[i] =
          ArrayOfWords[i].charAt(0).toUpperCase() + ArrayOfWords[i].slice(1);
      }
      const StringOfWords = ArrayOfWords.join(" ");
      setCourseName(StringOfWords);

      setIsLoading(false);
    }
    fetchData();
  }, [ResultID]);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const ExamObject = await GetSingleExam(ExamID);
      setExamData(ExamObject);

      const ArrayOfWords = ExamObject?.ExamName.split(" ");
      for (var i = 0; i < ArrayOfWords.length; i++) {
        ArrayOfWords[i] =
          ArrayOfWords[i].charAt(0).toUpperCase() + ArrayOfWords[i].slice(1);
      }
      const StringOfWords = ArrayOfWords.join(" ");
      setExamType(StringOfWords);
      setIsLoading(false);
    }
    fetchData();
  }, [ExamID]);

  useEffect(() => {
    const Ids = [];
    ResultData?.StudentsMarks?.map((item) => {
      return Ids.push(item?.id);
    });
    setUsersIds(Ids);
  }, [ResultData?.StudentsMarks]);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const UsersArray = await GetUsersIncludesInArray(UsersIds);
      setUsersData(UsersArray);
      setIsLoading(false);
    }
    fetchData();
  }, [UsersIds]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return {
    ExamData,
    ResultData,
    IsLoading,
    UsersData,
    ExamType,
    CourseName,
    componentRef,
    handlePrint,
  };
}
